<!--
    描述：项目成果验收
    日期：2022/9/26
    创建人：李家宝
-->
<template>
	<div>
		<el-empty description="暂无数据" v-if="tableData.length === 0"></el-empty>
		<template v-else>
			<div>
				当前项目投标人提交成果验收
				<span style="color: #0000FF">{{ tableData.length }}</span
				>次
			</div>
			<div class="mt10">
				<el-table :data="tableData" highlight-current-row row-key="id" border ref="table" style="width: 100%">
					<el-table-column label="更新日期" prop="createDate" align="center" show-overflow-tooltip width="161"></el-table-column>
					<el-table-column label="提交人" show-overflow-tooltip prop="submitter" align="center" width="121"> </el-table-column>
					<el-table-column label="成果交付" align="center" prop="diliverTypeName" width="151"> </el-table-column>
					<el-table-column label="成果说明" prop="explains" show-overflow-tooltip min-width="151"></el-table-column>
					<el-table-column label="成果文件/其它文件" show-overflow-tooltip min-width="171">
						<template slot-scope="scope">
							<div style="display: flex;align-items: center;justify-content: space-between">
								<div class="beyondHiding">
									<div
										v-for="(item, index) in busProjectFilePss"
										:key="index"
										class="link mr10"
										type="text"
										@click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
									>
										<span slot="reference">{{ item.fileName }}</span>
									</div>
								</div>

								<el-button class="bg" v-if="scope.row.sysFiles.length > 0" size="mini" @click="downloadAll(scope.row.sysFiles)"
									>批量下载</el-button
								>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="状态" align="center" prop="acceptStatus" width="100">
						<template slot-scope="scope">
							<div class="green" v-if="scope.row.acceptStatus === 0">
								待验收
							</div>
							<div class="green" v-if="scope.row.acceptStatus === 1">
								验收通过
							</div>
							<div class="red" v-if="scope.row.acceptStatus === 2">
								驳回
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="100">
						<template slot-scope="scope">
							<el-button size="mini" @click="viewProgress(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!--分页-->
			<div class="w-table-footer">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="pageList"
					:page-size="pageSize"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
				>
				</el-pagination>
			</div>
		</template>
		<!--弹窗-->
		<el-dialog :visible.sync="auditShow" width="50%" center title="查看" :close-on-click-modal="false" @close="closeDialog">
			<div class="dialog-box">
				<el-form label-width="150px">
					<el-row>
						<el-col :span="12">
							<el-form-item label="成果文件：">
								<div v-for="(item, index) in end_paper" :key="index">
									<div class="link" type="text" @click="viewFile(item.fileDirectory + item.serverName, item.fileName)">
										{{ item.fileName }}
									</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="其它资料：">
								<div v-for="(item, index) in else_paper" :key="index">
									<div class="link" type="text" @click="viewFile(item.fileDirectory + item.serverName, item.fileName)">
										{{ item.fileName }}
									</div>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="成果说明：">
								{{ currentRowData.explains }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="投标方提交人：">
								{{ currentRowData.submitter }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="提交时间：">
								{{ currentRowData.createDate }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="雇主方验收人：">
								{{ currentRowData.accepterName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="验收时间：">
								{{ currentRowData.updateDate }}
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="雇主方验收结果：">
								<div class="green" v-if="currentRowData.acceptStatus === 0">
									待验收
								</div>
								<div class="green" v-if="currentRowData.acceptStatus === 1">
									验收通过
								</div>
								<div class="red" v-if="currentRowData.acceptStatus === 2">
									驳回
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="驳回意见：" v-if="currentRowData.acceptStatus === 2">
								{{ currentRowData.examIdea }}
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getAcceptPageList, getAcceptDetail } from 'api/modules/projectManagement'
import VUE_CONFIG from '../../../../../vue.config'
export default {
	name: 'pro-result-acceptance',
	props: {
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			tableData: [],
			auditShow: false, // 审核弹窗的显隐
			btnLoading: false,
			currentRowData: {}, // 当前行数据
			end_paper: [], // 成果文件
			else_paper: [] // 其他文件
		}
	},
	methods: {
		// 获取列表数据
		getAcceptPageList() {
			getAcceptPageList({
				current: this.currentPage,
				size: this.pageSize,
				subProjectId: this.rowData.businessId
			}).then((res) => {
				if (res.operationCode == 1) {
					this.tableData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				}
			})
		},

		// 查看文件
		viewFile(filePath, fileName) {
			let uploadUrl = ''
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}
			this.$previewFn(uploadUrl + filePath, fileName)
		},

		// 查看进度
		viewProgress(currentRowData) {
			getAcceptDetail({ id: currentRowData.id }).then((res) => {
				if (res.operationCode == 1) {
					this.auditShow = true
					this.end_paper = []
					this.else_paper = []
					res.data.sysFiles.map((item) => {
						if (item.assortment === 'end_paper') {
							this.end_paper.push(item)
						} else if (item.assortment === 'else_paper') {
							this.else_paper.push(item)
						}
					})
					this.currentRowData = res.data
				}
			})
		},

		// 批量下载
		downloadAll(list) {
			list.map((item) => {
				const url = process.env.VUE_APP_UPLOAD_URL + item.fullFilePath
				const iframe = document.createElement('iframe')
				iframe.style.display = 'none' // 防止影响页面
				iframe.style.height = 0 // 防止影响页面
				iframe.src = url
				document.body.appendChild(iframe) // 这一行必须，iframe挂在到dom树上才会发请求
				// 2分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
				setTimeout(() => {
					iframe.remove()
				}, 2 * 60 * 1000)
				// window.open(process.env.VUE_APP_UPLOAD_URL + item.fullFilePath, '_self', true)
			})
		},

		// close 审查弹框
		closeDialog() {
			this.auditShow = false
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getAcceptPageList()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getAcceptPageList()
		}
	},

	created() {},

	mounted() {}
}
</script>

<style scoped>
.w-table-footer {
	display: flex;
	justify-content: center;
	margin: 20px;
}
.el-button {
	background-color: #199ed8;
	color: white;
}
.green:before,
.red:before {
	display: inline-block;
	content: '';
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #1aa235;
}
.red:before {
	background-color: red;
}
.bg {
	background-color: #ff9900 !important;
}
.link {
	color: #0000ff;
	cursor: pointer;
	text-decoration: underline;
}
.beyondHiding {
	width: 700px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
